import React from "react"
import {
  sponsor as sponsorClass,
  sponsorImageWrapper,
  sponsorTxt,
} from "./sponsor.module.css"
import { GatsbyImage } from "gatsby-plugin-image"
import { trackExternalLink } from "../../services/tracking"
import { getUid } from "../../services/auth"
import { dataLayer } from "../../modules/analytics"
import MediaImage from "../media-image/media-image"

const Sponsor = ({ sponsor }) => {
  const trackEvent = async () => {
    dataLayer({
      event: "website-interaction",
      category: "sponsorbox",
      action: `external-link:${sponsor.url}`,
      label: sponsor.name,
    })
    trackExternalLink(await getUid(), sponsor.contentful_id, sponsor.url)
  }
  return (
    <a
      id="sponsor"
      href={sponsor.url}
      rel="sponsored noopener noreferrer"
      target="_blank"
      className={sponsorClass}
      onClick={trackEvent}
    >
      <span>Mogelijk gemaakt door:</span>
      <div className={sponsorImageWrapper}>
        {sponsor.image && (
          <MediaImage image={sponsor.image} alt={sponsor.name} />
        )}
      </div>
      <p className={sponsorTxt}>
        {sponsor.description.childMarkdownRemark.rawMarkdownBody}
      </p>
    </a>
  )
}

export default Sponsor
